import { IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import * as React from 'react';

import { getRandomId } from '../../utils/banners';
import { IMakeRequest } from '../../utils/make_request';
import { addAdFoxBanner } from '../adfox/index';
import { getRailwayAndHighwaysPuids } from '../../utils/adfox';

const PR1_RANDOM = getRandomId();

export interface IStretchBannerProps {
  makeRequest: IMakeRequest;
  offer: IOfferSchema;
  user: IUserSchema | null;
}

export class StretchBanner extends React.PureComponent<IStretchBannerProps, {}> {
  public render() {
    const { user } = this.props;

    return (
      <div>
        {addAdFoxBanner({
          type: 'stretch',
          key: 'stretch',
          makeRequest: this.props.makeRequest,
          offer: this.props.offer,
          randomId: PR1_RANDOM,
          positionInfo: 'offer_card_stretch-1',
          isAgent: !!user && !!user.isAgent,
          additionalPuids: getRailwayAndHighwaysPuids(this.props.offer),
        })}
      </div>
    );
  }
}
